import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {AdministratorsActions} from '../store';
import {AdministratorsSelectors} from '../store/selectors';

@Injectable()
export class AdministratorsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadAdministratorsDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadAdministratorsDone() {
    return this.store.pipe(
      select(AdministratorsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(AdministratorsActions.ReadAdministrators());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
